export default {
    props: {
        // event line option
        eventIndex: Number,
        eventColor: {
            type: String,
            default: 'rgba(150, 150, 150, 1)'
        },
        // line option
        area: Boolean,
        smooth: Boolean,
        circle: Boolean,
        radius: {
            type: Number,
            default: 10
        },
        autoDraw: Boolean,
        autoDrawDuration: {
            type: Number,
            default: 2000
        },
        autoDrawEasing: {
            type: String,
            default: 'ease'
        },
        lineColor: {
            type: Object
        },
        opacity: {
            type: Number,
            default: 0.3
        }
    }
}
